import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/api';

export const EXECUTIVE_SUMMARY_VARIANT_FULL = 'full';
export const EXECUTIVE_SUMMARY_VARIANT_TEXT_ONLY = 'text_only';

const getVariantParams = variant =>
  variant === EXECUTIVE_SUMMARY_VARIANT_TEXT_ONLY ? { accessible: 'true' } : {};

// This API slice is dedicated to the /documents/ path
export const documentsApi = createApi({
  reducerPath: 'documentsApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/documents/',
  }),
  endpoints: builder => ({
    exportProgramExecutiveSummaries: builder.mutation({
      query: programId => ({
        url: 'download-program-executive-summaries/',
        params: { program: programId },
        method: 'GET',
      }),
    }),
    downloadExecutiveSummary: builder.query({
      query: ({ projectId, variant = EXECUTIVE_SUMMARY_VARIANT_FULL }) => ({
        url: 'executive-summary/',
        params: { project_id: projectId, ...getVariantParams(variant) },
        responseType: 'blob',
      }),
    }),
  }),
});

export const { useExportProgramExecutiveSummariesMutation, useLazyDownloadExecutiveSummaryQuery } =
  documentsApi;
